import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { _router } from "./routes";
import SmoothScroll from "./components/SmoothScroll";

const App = () => {
    useEffect(() => {
        const data = fetch(`https://lic-agent-api.onrender.com/api/v1/restart`);
        console.log("lic-agent-api data>>", data);

        const data1 = fetch(
            `https://emphasisetech-api.onrender.com/api/v1/restart`,
        );
        console.log("emphasisetech-api data1>>", data1);

        const data3 = fetch(
            `https://emp-prod-apis.onrender.com/api/v1/restart`,
        );
        console.log("emp-prod-apis data>>", data3);

        const data4 = fetch(
            `https://leadgen-api-58tl.onrender.com/api/v1/restart`,
        );
        console.log("leadgen-api-58tl data>>", data4);

        const data5 = fetch(
            `https://left-right-api.onrender.com/api/v1/restart`,
        );
        console.log("left-right-api data>>", data5);
    }, []);
    return <RouterProvider router={_router} />;
};

export default App;
